export type RuntimePlatform = "android" | "ios" | "browser";
export type DeviceClass = "mobile" | "tablet" | "desktop";

export type PlatformEnvironment = {
  runtime: RuntimePlatform;
  deviceClass: DeviceClass;
  hasFinePointer: boolean;
  hasHover: boolean;
};

function runtimeFromNavigator(): RuntimePlatform {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("android")) {
    return "android";
  }
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios";
  }
  return "browser";
}

function deviceClassFromViewport(width: number): DeviceClass {
  if (width >= 1200) {
    return "desktop";
  }
  if (width >= 768) {
    return "tablet";
  }
  return "mobile";
}

export function getPlatformEnvironment(): PlatformEnvironment {
  return {
    runtime: runtimeFromNavigator(),
    deviceClass: deviceClassFromViewport(window.innerWidth),
    hasFinePointer: window.matchMedia("(pointer: fine)").matches,
    hasHover: window.matchMedia("(hover: hover)").matches,
  };
}
